<template>
  <div class="row">
    <div class="col-12">
      <page-header
        left-side-class="col-8"
        right-side-class="col-4 d-flex align-items-center"
        :page="headerConfig"
      />
    </div>
    <div class="col-12">
      <filter-manager
        v-model="filters"
        :display-advanced="false"
        :filters="filterConfig"
        @search="filterSearchHandler"
      />
    </div>
    <div class="col-12">
      <custom-separator class="my-4" text="Resultados" />
      <custom-result-not-found v-if="resultsEmpty" />
      <div v-for="(row, i) of results" :key="`result-${i}`" class="mx-3">
        <result-row :data="row" />
      </div>
      <pagination
        v-if="showPagination"
        show-text
        :data="pagination"
        @pagination-go-page="goToPage"
      />
    </div>
  </div>
</template>

<script>
import loadingMixin from "@quisit/mipe-utils/mixins/loading";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

import PageHeader from "PageHeader";
import Pagination from "pagination";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import ResultRow from "./components/ResultRow.vue";

import {
  getQuestionnaireSamples,
  getQuestionnaireFilterOptions
} from "@/services/teacherSatisfactionQuestionnaire.js";

import { semesters as SEMESTERS } from "@/utils/constants/questionnaire-sample/codeQuestionnaireSamplePeriodNumber.js";

const DEFAULT_PAGE_SIZE = 20;

export default {
  name: "teacherSatisfactionQuestionnaireManagement",
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow
  },
  mixins: [alertMixin, loadingMixin],
  data() {
    return {
      results: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
        pageSize: DEFAULT_PAGE_SIZE
      },
      filterOptions: {
        academicYears: [],
        submissionStatuses: [],
        semesters: []
      },
      filters: {
        academicYear: null,
        status: null,
        semester: null
      }
    };
  },
  async mounted() {
    await this.getFilters();
    await this.onSearchHandler();
  },
  computed: {
    headerConfig() {
      return {
        icon: "fas fa-clipboard-list-check",
        title: "Cuestionario de Satisfacción para Maestros",
        routes: [
          "Inicio",
          "Estudiantes",
          "Cuestionario de Satisfacción para Maestros"
        ]
      };
    },
    filterConfig() {
      return [
        {
          name: "academicYear",
          component: "CustomDropDown",
          options: this.filterOptions.academicYears,
          value: this.filters.academicYear,
          placeholder: "Año Académico",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-4"
        },
        {
          name: "status",
          component: "CustomDropDown",
          options: this.filterOptions.submissionStatuses,
          value: this.filters.status,
          placeholder: "Estatus",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-4"
        },
        {
          name: "semester",
          component: "CustomDropDown",
          options: this.filterOptions.semesters,
          value: this.filters.semester,
          placeholder: "Semestre",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-4"
        }
      ];
    },
    currentAcademicYearId() {
      return this.currentAcademicYear().id;
    },
    resultsEmpty() {
      return this.results.length === 0;
    },
    getFilterValues() {
      return {
        academicYearId:
          this.filters.academicYear?.id ?? this.currentAcademicYearId,
        submissionStatusId: this.filters.status?.id,
        periodNumber: this.filters.semester?.id
      };
    },
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    }
  },
  methods: {
    async getFilters() {
      const { data } = await getQuestionnaireFilterOptions();
      data.collections.semesters = [...SEMESTERS];
      this.filterOptions = { ...data.collections };
      this.filters.academicYear = this.filterOptions.academicYears.find(
        x => x.id === this.currentAcademicYearId
      );
    },
    async goToPage(page) {
      this.pagination.currentPage = page;
      await this.onSearchHandler();
    },
    async filterSearchHandler() {
      this.pagination.currentPage = 1;
      this.onSearchHandler();
    },
    async onSearchHandler() {
      const params = { ...this.getFilterValues };
      const payload = {
        ...params,
        pageSize: this.pagination.pageSize,
        pageIndex: this.pagination.currentPage
      };
      const { data } = await getQuestionnaireSamples(payload);
      this.results = [...data.data];
      this.pagination = {
        ...this.pagination,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count
      };
    }
  }
};
</script>

<style scoped lang="scss">
.alert-container {
  background-color: #fef5e8 !important;
  em,
  div {
    color: #b0690b;
  }
}
</style>
